import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { IntegrationsPanel } from "@/features/admin/components/integrations-panel";
import { PageContainer } from "@fleet/ui/page-container";

function AdminIntegrationsPage() {
  return (
    <PageContainer maxWidth="4xl">
      <IntegrationsPanel />
    </PageContainer>
  );
}

export const adminIntegrationsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/integrations",
  component: AdminIntegrationsPage,
});
